import { createRequestTypes, action } from '../utils/actions';
import { REQUEST, SUCCESS, FAILURE } from '../utils/constants';

export const GET_MEMBERS = createRequestTypes('GET_MEMBERS');
export const GET_ACTIVE_MEMBERS = createRequestTypes('GET_ACTIVE_MEMBERS');
export const GET_INACTIVE_MEMBERS = createRequestTypes('GET_INACTIVE_MEMBERS');
export const GET_MEMBER = createRequestTypes('GET_MEMBER');

export const CREATE_MEMBER = createRequestTypes('CREATE_MEMBER');
export const CREATE_MEMBER_BY_ADMIN = createRequestTypes('CREATE_MEMBER_BY_ADMIN');
export const UPDATE_MEMBER = createRequestTypes('UPDATE_MEMBER');
export const UPDATE_MEMBER_BY_ADMIN = createRequestTypes('UPDATE_MEMBER_BY_ADMIN');
export const UPDATE_MEMBER_PASSWORD = createRequestTypes('UPDATE_MEMBER_PASSWORD');
export const DELETE_MEMBER = createRequestTypes('DELETE_MEMBER');
export const DELETE_MEMBER_BY_ADMIN = createRequestTypes('DELETE_MEMBER_BY_ADMIN');

export const GET_ROLES = createRequestTypes('GET_ROLES');

export const SET_MEMBER_TABLE_FILTER = 'SET_MEMBER_TABLE_FILTER';
export const SET_MEMBER_TABLE_SORTING = 'SET_MEMBER_TABLE_SORTING';

export const getMembers = {
  request: (data) => action(GET_MEMBERS[REQUEST], { data }),
  success: (payload) => action(GET_MEMBERS[SUCCESS], { payload }),
  failure: (payload) => action(GET_MEMBERS[FAILURE], { payload }),
};

export const getActiveMembers = {
  request: (data) => action(GET_ACTIVE_MEMBERS[REQUEST], { data }),
  success: (payload) => action(GET_ACTIVE_MEMBERS[SUCCESS], { payload }),
  failure: (payload) => action(GET_ACTIVE_MEMBERS[FAILURE], { payload }),
};

export const getInactiveMembers = {
  request: (data) => action(GET_INACTIVE_MEMBERS[REQUEST], { data }),
  success: (payload) => action(GET_INACTIVE_MEMBERS[SUCCESS], { payload }),
  failure: (payload) => action(GET_INACTIVE_MEMBERS[FAILURE], { payload }),
};

export const getMember = {
  request: (id) => action(GET_MEMBER[REQUEST], { id }),
  success: (payload) => action(GET_MEMBER[SUCCESS], { payload }),
  failure: (payload) => action(GET_MEMBER[FAILURE], { payload }),
};

export const createMember = {
  request: (data) => action(CREATE_MEMBER[REQUEST], { data }),
  success: (payload) => action(CREATE_MEMBER[SUCCESS], { payload }),
  failure: (payload) => action(CREATE_MEMBER[FAILURE], { payload }),
};

export const createMemberByAdmin = {
  request: (data) => action(CREATE_MEMBER_BY_ADMIN[REQUEST], { data }),
  success: (payload) => action(CREATE_MEMBER_BY_ADMIN[SUCCESS], { payload }),
  failure: (payload) => action(CREATE_MEMBER_BY_ADMIN[FAILURE], { payload }),
};

export const updateMember = {
  request: (id, data) => action(UPDATE_MEMBER[REQUEST], { id, data }),
  success: (payload) => action(UPDATE_MEMBER[SUCCESS], { payload }),
  failure: (payload) => action(UPDATE_MEMBER[FAILURE], { payload }),
};

export const updateMemberByAdmin = {
  request: (id, data) => action(UPDATE_MEMBER_BY_ADMIN[REQUEST], { id, data }),
  success: (payload) => action(UPDATE_MEMBER_BY_ADMIN[SUCCESS], { payload }),
  failure: (payload) => action(UPDATE_MEMBER_BY_ADMIN[FAILURE], { payload }),
};

export const updateMemberPassword = {
  request: (data) => action(UPDATE_MEMBER_PASSWORD[REQUEST], { data }),
  success: (payload) => action(UPDATE_MEMBER_PASSWORD[SUCCESS], { payload }),
  failure: (payload) => action(UPDATE_MEMBER_PASSWORD[FAILURE], { payload }),
};

export const deleteMember = {
  request: (id) => action(DELETE_MEMBER[REQUEST], { id }),
  success: (payload) => action(DELETE_MEMBER[SUCCESS], { payload }),
  failure: (payload) => action(DELETE_MEMBER[FAILURE], { payload }),
};

export const deleteMemberByAdmin = {
  request: (id) => action(DELETE_MEMBER_BY_ADMIN[REQUEST], { id }),
  success: (payload) => action(DELETE_MEMBER_BY_ADMIN[SUCCESS], { payload }),
  failure: (payload) => action(DELETE_MEMBER_BY_ADMIN[FAILURE], { payload }),
};

export const getRoles = {
  request: () => action(GET_ROLES[REQUEST]),
  success: (payload) => action(GET_ROLES[SUCCESS], { payload }),
  failure: (payload) => action(GET_ROLES[FAILURE], { payload }),
};

export const setMembersTableFilter = (payload) => ({
  type: SET_MEMBER_TABLE_FILTER,
  payload,
});

export const setMembersTableSorting = (payload) => ({
  type: SET_MEMBER_TABLE_SORTING,
  payload,
});
